// src/polyfills.js
import { Buffer } from 'buffer';

// Add Buffer to the global object
window.Buffer = window.Buffer || Buffer;
